/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1LibrarycodeprefixesQueryResponse } from '../../types/GetV1Librarycodeprefixes.ts'

export const getV1LibrarycodeprefixesQueryKey = () => [{ url: '/v1/LibraryCodePrefixes' }] as const

export type GetV1LibrarycodeprefixesQueryKey = ReturnType<typeof getV1LibrarycodeprefixesQueryKey>

/**
 * {@link /v1/LibraryCodePrefixes}
 */
export async function getV1Librarycodeprefixes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1LibrarycodeprefixesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/LibraryCodePrefixes`, ...requestConfig })
    return res
}

export function getV1LibrarycodeprefixesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1LibrarycodeprefixesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1LibrarycodeprefixesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1LibrarycodeprefixesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Librarycodeprefixes(config)
        },
    })
}

/**
 * {@link /v1/LibraryCodePrefixes}
 */
export function useGetV1Librarycodeprefixes<
    TData = ResponseConfig<GetV1LibrarycodeprefixesQueryResponse>,
    TQueryData = ResponseConfig<GetV1LibrarycodeprefixesQueryResponse>,
    TQueryKey extends QueryKey = GetV1LibrarycodeprefixesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1LibrarycodeprefixesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1LibrarycodeprefixesQueryKey()

    const query = useQuery(
        {
            ...getV1LibrarycodeprefixesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
